<div class="flex flex-col" *ngIf="eventsStore.state$ | async as state">
  <div
    class="list-container"
    [class.loading]="state.loading"
    infinite-scroll
    [infiniteScrollDistance]="1"
    [infiniteScrollThrottle]="50"
    (scrolled)="loadData()"
    [scrollWindow]="false"
    infiniteScrollContainer="app-overlay"
    [fromRoot]="true"
  >
    <app-event-item *ngFor="let event of buffer" [event]="event"> </app-event-item>
    <vi-loader [isLoading]="state.loading" message=""></vi-loader>
  </div>

  <div
    class="no-events-text flex flex-row justify-center items-center"
    data-at-no-events-found
    *ngIf="!state.loading && !state.error && !state.events.length"
  >
    {{ '+INSTALLATIONS.INSTALLATION.EVENT_LOG.NO_EVENTS_FOUND' | translate }}
  </div>
</div>
